// Sous-plan 5 : la SPA sert sous un sous-chemin (VITE_BASE_PATH=/chat/). Le routeur ajoute la
// base a chaque navigation ; un chemin construit depuis window.location.pathname (par exemple
// useAgentFromSearchParam) la porte deja. Ce module pur la retire une fois. Base "/" ou vide :
// rien a retirer. Une URL absolue ou un chemin relatif sont rendus tels quels.

export function stripBasePath(url: string, base: string): string {
  const b = (base || "/").replace(/\/+$/, "");
  if (!b || !url.startsWith("/")) {
    return url;
  }
  if (url === b) {
    return "/";
  }
  const suivant = url.charAt(b.length);
  if (
    url.startsWith(b) &&
    (suivant === "/" || suivant === "?" || suivant === "#")
  ) {
    const reste = url.slice(b.length);
    return reste.startsWith("/") ? reste : `/${reste}`;
  }
  return url;
}
